// src/locales/en/nav.js
export const nav = {
    dashboard: "උපකරණ පුවරුව",
    orders: "ඇණවුම්",
    onlineOrders: "මාර්ගගත විකුණුම්",
    products: "නිෂ්පාදන",
    inventory: "ඉන්වෙන්ටරි",
    procurement: "ප්‍රසම්පාදනය",
    users: "පරිශීලක කළමනාකරණය",
    shops: "වෙළඳසැල්",
    reports: "වාර්තා",
    settings: "සැකසුම්",
    logout: "ඉවත්වන්න",
    profile: "පැතිකඩ",
    couriers: "කූරියර්ස්"
}